import { apiPost, apiPut } from "@redriver/cinnamon";
import { requestAuthentication } from "../AuthenticatorCheck";

const NAMESPACE = "SYSTEM/AUTHENTICATOR_SETUP";

const ActionTypes = {
  RequestRegistration: `${NAMESPACE}/REQUEST_REGISTRATION`,
  CompleteRegistration: `${NAMESPACE}/COMPLETE_REGISTRATION`,
};

export const requestRegistration = (token) =>
  apiPost(
    ActionTypes.RequestRegistration,
    "auth/mfa/totp/register",
    { token },
    { auth: false, preventErrorNotification: true }
  );

export const completeRegistration = ({ totp }, { token, recovery }) => async (
  dispatch
) => {
  const regAction = apiPut(
    ActionTypes.CompleteRegistration,
    "auth/mfa/totp/register",
    { token, totp, recovery },
    { auth: false, preventErrorNotification: true }
  );

  const result = await dispatch(regAction);
  if (!result.success) return result;

  // don't log the user in yet - they still need to confirm they've saved
  // their recovery codes, so the tokens are held and applied explicitly
  // once they click Continue (see AuthenticatorSetup.js)
  const authResult = await dispatch(
    requestAuthentication({ totp }, token, { applyAuth: false })
  );
  if (!authResult.success) return authResult;

  // "codes" (from the registration response) reaches AuthenticatorSetup's onSubmitted
  // via result.response, so tokens has to live there too rather than as a sibling of
  // it, or FormBuilder's unwrapping drops it before onSubmitted ever sees it
  return {
    ...result,
    response: { ...result.response, tokens: authResult.response.tokens },
  };
};
